import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuTrigger, MatMenuModule } from '@angular/material/menu';
import { IReminders } from 'app/config';
import { TranslateModule } from '@ngx-translate/core';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgFor, NgIf } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { TranslateSelectorPipe } from '@helpers/pipes';

@Component({
    selector: 'aw-reminders',
    templateUrl: 'reminders.component.html',
    styleUrls: ['./reminders.component.scss'],
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatListModule,
        NgFor,
        MatIconModule,
        MatButtonModule,
        NgIf,
        MatMenuModule,
        MatFormFieldModule,
        MatInputModule,
        MatRadioModule,
        MatSelectModule,
        MatOptionModule,
        TranslateModule,
        TranslateSelectorPipe,
    ],
})
export class RemindersComponent implements OnInit {
    @Input() form: UntypedFormGroup;
    @Input() config: IReminders;
    @Input() remindersKey = 'reminders';
    @ViewChild(MatMenuTrigger) popoverTrigger: MatMenuTrigger;
    newReminderForm: UntypedFormGroup;

    frequencies = [
        {
            value: 'minutes',
            label: 'minuter',
        },
        {
            value: 'hours',
            label: 'timmar',
        },
        {
            value: 'days',
            label: 'dagar',
        },
    ];

    channels = [
        {
            value: 'post',
            label: 'Deltagare',
        },
        {
            value: 'unit',
            label: 'Alla på enheten',
        },
    ];

    get reminders(): UntypedFormArray {
        return this.form.get(this.remindersKey) as UntypedFormArray;
    }

    constructor(private fb: UntypedFormBuilder) {}

    ngOnInit() {
        this._buildForm();
    }

    addReminder() {
        this.reminders.push(this.newReminderForm);

        this.popoverTrigger.closeMenu();
        this._buildForm();
    }

    removeReminder(index: number) {
        const reminder = this.reminders.at(index);

        if (reminder.get('uuid').value) {
            reminder.get('toDelete').setValue(!reminder.get('toDelete').value);
        } else {
            this.reminders.removeAt(index);
        }
    }

    private _buildForm() {
        if (!this.form.get(this.remindersKey)) {
            this.form.addControl(this.remindersKey, new UntypedFormArray([]));
        }

        this.newReminderForm = this.fb.group({
            uuid: null,
            toDelete: false,
            date: null,
            amount: [10, Validators.required],
            frequency: 'minutes',
            inherit: 'post',
        });
    }
}
